import React from "react";
import cross from "../../../assets/images/cross.svg";
import exchangeBellIcon from "../../../assets/images/bellIconSvg.svg";
import { Button, Modal } from "react-bootstrap";
import "./exchangeConnectionModal.css";

const ExchangeConnectionModal = ({ setDisplayWarningModal }) => {
  return (
    <div className="exchangeConnectionModal">
      <Modal
        backdrop="false"
        id="exchangeConnectionModal"
        // onHide={() => {
        //   setShowDeleteModel({ apiObj: {}, show: false });
        // }}

        show={true}
      >
        <Modal.Body>
          <div className="modalContent">
            <Button
              className="closeBtn"
              onClick={() => {
                setDisplayWarningModal(false);
              }}
            >
              <img alt="Close Modal" src={cross} />
            </Button>
            <div className="regBox">
              <div className="img-box">
                <img alt="Success Bell" src={exchangeBellIcon} />
              </div>
              <div className="content-box">
                <p>
                  <span>Exchange not connected!</span>
                  <br />
                  You need to connect exchange to verify your trades.
                </p>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ExchangeConnectionModal;
